import { render } from "./FattureClientiDetail.vue?vue&type=template&id=f35fdf9a&scoped=true"
import script from "./FattureClientiDetail.vue?vue&type=script&lang=js"
export * from "./FattureClientiDetail.vue?vue&type=script&lang=js"

import "./FattureClientiDetail.vue?vue&type=style&index=0&id=f35fdf9a&scoped=true&lang=css"

import exportComponent from "/Users/gigi/Library/ask_admin-deps/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f35fdf9a"]])

export default __exports__